module.exports = __webpack_public_path__ + "static/media/cert_AUA_UD_I.25c31138.jpg";